export default class ObjectHelper {
  static isEmpty(obj) {
    return JSON.stringify(obj) === '{}';
  }

  static map(obj, callback) {
    Object.keys(obj).forEach(key => {
      obj[key] = callback(obj[key], key, obj);
    });
    return obj;
  }

  static parseToObject(data) {
    return data instanceof Object ? data : {};
  }
}
